<template>
  <div>
    <div class="row" v-if="activity.status != 'COMPLETED' && activity.status != 'REJECTED' && activity.status != 'CANCELLED'">
      <b-form-group
        id="input-topic-type"
        :label="$t('training-view.topicType')"
        label-for="topic-type"
        label-align="left"
        class="col-2"
      >
        <b-select
        id="topic-type"
        v-model="topicToAdd.type" 
        :options="topicTypes"
        @change="typeChanged">
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-training-session"
        :label="$t('training-view.sessionTitle')"
        label-for="input-session"
        label-align="left"
        class="col-4"
      > 
        <b-form-input list="input-list" id="input-with-list" v-model="topicToAdd.session.title" :disabled="topicToAdd.type == 'LESSON' && availableSessions.length < 1"></b-form-input>
        <b-form-datalist id="input-list" :options="availableSessions"></b-form-datalist>
      </b-form-group>
      <b-form-group
        id="input-training-leader"
        :label="$t('training-view.lecturer')"
        label-for="input-leader"
        label-align="left"
        class="col-4"
      >
        <v-select
          :options="availableLeaders"
          placeholder=""
          :clearable='false'
          v-model="topicToAdd.trainer"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("training-add.noTrainers") }}
          </template>
        </v-select>
      </b-form-group>
      <b-button variant="primary" class="esep-blue-bg col-lg-1 col-sm-2 w-50 h-50 my-auto" @click="addTopic()"
        :disabled="topicToAdd.trainer.id == null || topicToAdd.session.title == null">
          {{ $t("common.add")}}</b-button>
      <hr />
    </div>
    <b-table 
      :items="sessions"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteTopic(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('training-view.deleteTopic')"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyTopicsTable") }}</h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import { handleApiError } from "../../services/error.service";

export default {
  computed: {
    availableLeaders() {
      let leaders = [];
      this.activity.leaders.forEach(leader => {
        if(leader.position != 'ASSOCIATE') {
          leaders.push({label: leader.member.surName + " " + leader.member.firstName , id: leader.member.id, position: leader.position})
        } else {
          leaders.push({label: leader.associateName , id: 0, position: leader.position})
        }
        
      });
      return leaders;
    }
  },
  props: {
    activity: {
      type: Object
    },
    sessions: {
      type: Array
    }
  },
  data() {
    return {
      topicToAdd: {
        type: 'LESSON',
        session: {
          title: null
        },
        trainer: {
          id: null
        }
      },
      topicTypes: [
        { value: 'LESSON', text: this.$t('training-view.LESSON') },
        { value: 'ACTION', text: this.$t('training-view.ACTION') },
      ],
      fields: [
        { key: "session.title", label: "Θέμα / Δραστηριότητα", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "trainer", label: "Εκπαιδευτής", sortable: false , formatter: (value, key, item) => {
          return value? value.surName + " " + value.firstName: item.associateName;
          // return value.surName + " " + value.firstName;
          }, thClass: 'text-left', tdClass: 'text-left'
        },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      availableSessions: null,
      lessons: null,
      actions: null
    }
  },
  mounted() {
    this.getSessionsByCriteria();
  },
  methods: {
    typeChanged() {
      if(this.topicToAdd.type == 'LESSON') {
        this.availableSessions = this.lessons;
      } else {
        this.availableSessions = this.actions;
      }
    },
    getSessionsByCriteria() {
      trainingService.getSessionsByCriteria(this.activity.module.id).then(
        (response) => {
          this.$log.debug('availableSessions')
          this.$log.debug(response.data)
          let lessons = [];
          let actions = [];
          response.data.forEach(session => {
            if(session.type == 'LESSON') {
              lessons.push( session.title);
            } else {
              actions.push( session.title );
            }
          })
          this.lessons = lessons;
          this.actions = actions;
          this.availableSessions = lessons;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    addTopic() {
      this.$log.error(this.topicToAdd);
      trainingService.addSessionToActivity(this.activity.id, this.topicToAdd.session.id != null ? this.topicToAdd.session.id : null ,
         this.topicToAdd.session.title , this.topicToAdd.trainer?.id, this.topicToAdd.trainer.label).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-sessions');
          this.topicToAdd = { 
            type: 'LESSON',
            session: {
              title: null
            },
            trainer: {
              id: null
            }
          } 
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    deleteTopic(row) {
      trainingService.deleteActivitySession(this.activity.id, row.item.id).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-sessions');
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>